import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import WhitelistIp from './AppUIWhitelistIp'
import {
  deleteWhitelistIp,
  createWhitelistIp,
  getListHotels,
} from "actions/appUIAction";

const mapStateToProps = state => {
    return {
        hotelState: state.hotelReducer,
        appUIState: state.appUIReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        deleteWhitelistIp: (id) => dispatch(deleteWhitelistIp(id)),
        createWhitelistIp: (ipData) => dispatch(createWhitelistIp(ipData)),
        getListHotels: (filters) => dispatch(getListHotels(filters)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(WhitelistIp));
